// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/wrongBrowser/stylesheet/style.sass
 ** module id = 391
 ** module chunks = 1
 **/